import { render, staticRenderFns } from "./scoreRoundManage.vue?vue&type=template&id=562b7c77&scoped=true&"
import script from "./scoreRoundManage.vue?vue&type=script&lang=ts&"
export * from "./scoreRoundManage.vue?vue&type=script&lang=ts&"
import style0 from "./scoreRoundManage.vue?vue&type=style&index=0&id=562b7c77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562b7c77",
  null
  
)

export default component.exports